

export interface GraphSpec {
    path: string,
    description: string,
    url?: string,
}

export class GraphRegistry {
    static instance = new GraphRegistry()

    specs : GraphSpec[] = []

    constructor() {

        this.specs.push({
            path: "unix.gv",
            description: "Unix History Graph",
            url: "https://graphviz.org/Gallery/directed/unix.html"
        })
        this.specs.push({
            path: "kernel_diagram.gv",
            description: "Linux Kernel Diagram",
            url: "https://graphviz.org/Gallery/directed/Linux_kernel_diagram.html"
        })
        this.specs.push({
            path: "cluster.gv",
            description: "Cluster",
            url: "https://graphviz.org/Gallery/directed/cluster.html"
        })
        this.specs.push({
            path: "world.gv",
            description: "World Dynamics",
            url: "https://graphviz.org/Gallery/directed/world.html"
        })
        this.specs.push({
            path: "crazy.gv",
            description: "Polygons / Crazy",
            url: "https://graphviz.org/Gallery/directed/crazy.html"
        })
        this.specs.push({
            path: "radial.gv",
            description: "Radial Module Dependencies",
            url: "https://graphviz.org/Gallery/undirected/softmaint.html"
        })
        this.specs.push({
            path: "nodemodules_graphviewer.gv",
            description: "NPM Dependencies of Graphviewer",
        })
        this.specs.push({
            path: "flowchart.gv",
            description: "Erlöskonten-Bestimmung",
            url: "https://www.scopevisio.com"
        })

    }

    getSpecs() {
        return this.specs.slice(0)
    }
}